export default __webpack_public_path__ + "static/media/Ceramic-Logo.a482f779.png";